import { Component, OnInit } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { GoogleAnalyticsService } from 'ngx-google-analytics';

@Component({
  selector: 'app-erro-500',
  templateUrl: './erro-500.component.html',
  styleUrls: ['./erro-500.component.scss']
})

export class Erro500Component implements OnInit {
  data: any;

  constructor(
    private translate: TranslateService,
    private titleService: Title,
    private meta: Meta,
    private router: Router,
    private gaService: GoogleAnalyticsService
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.carregarDados();
    });
  }

  ngOnInit() {
    this.carregarDados();
  }

  carregarDados() {
    this.translate.get('ERRO.500').subscribe(res => {
      this.data = res;
      this.titleService.setTitle(this.data.HEADER_TITLE);
      this.meta.updateTag({name: 'description', content: this.data.META_DESCRIPTION});
      this.meta.updateTag({name: 'keywords', content:  this.data.META_KEYWORDS});
      this.gaService.pageView(this.router.url);
    });
  }

}
